export const rankToSkillRating = (rank: string) => {
	switch (rank) {
		case 'bronze': return 1499;
		case 'silver': return 1999;
		case 'gold': return 2499;
		case 'platinum': return 2999;
		case 'diamond': return 3499;
		case 'masters': return 3999;
		case 'grandmaster': return 5000;
		default: return 0;
	}
};
